module.exports = __webpack_public_path__ + "img/tag_leaf.a41b1532.svg";